import { projectRequest } from 'store/utils/request';

export const getFilesRequest = async () => {
  try {
    return await projectRequest.get(`/nlu_resources/directories/`);
  } catch (error) {
    throw error;
  }
};

export const getFileRequest = async path => {
  try {
    return await projectRequest.get(`/nlu_resources/blobs/${path}/`);
  } catch (error) {
    throw error;
  }
};

export const addFileRequest = async path => {
  try {
    return await projectRequest.post(`/nlu_resources/blobs/${path}/`);
  } catch (error) {
    throw error;
  }
};

export const uploadFileRequest = async (file, config = {}) => {
  try {
    const data = new FormData();
    data.append('contents', file, file.name);

    const defaultConfig = {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      },
      timeout: 60000,
      ...config,
    };

    return await projectRequest.post(
      `/nlu_resources/blobs/${file.name}/`,
      data,
      defaultConfig,
    );
  } catch (error) {
    throw error;
  }
};

export const updateFileRequest = async (path, data) => {
  try {
    return await projectRequest.put(`/nlu_resources/entries/${path}/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteFileRequest = async path => {
  try {
    return await projectRequest.delete(`/nlu_resources/entries/${path}/`);
  } catch (error) {
    throw error;
  }
};

export const updateBlobRequest = async (path, data) => {
  try {
    return await projectRequest.put(`/nlu_resources/blobs/${path}/`, data);
  } catch (error) {
    throw error;
  }
};

export const deleteFilesRequest = async data => {
  try {
    return await projectRequest.post(`/nlu_resources/multi/`, data);
  } catch (error) {
    throw error;
  }
};

export const exportFilesRequest = async data => {
  try {
    return await projectRequest.post(`/nlu_resources/export/`, data, {
      responseType: 'blob',
      timeout: 60000,
    });
  } catch (error) {
    throw error;
  }
};
